import { withInstall } from '@ll-plus/utils'

import DropdownButtonSimple from './src/dropdown-button-simple.vue'

export const LlDropdownButtonSimple = withInstall(DropdownButtonSimple)
export default LlDropdownButtonSimple
export * from './src/dropdown-button-simple'

declare module 'vue' {
  export interface GlobalComponents {
    LlDropdownButtonSimple: typeof DropdownButtonSimple
  }
}
